<<template>
    <div>
        <feather type="eye" v-if="value === 'text'" class="custom-class stdSize" @click="changeValue('password')"></feather>
		<feather type="eye-off" v-if="value === 'password'" class="custom-class stdSize" @click="changeValue('text')"></feather>
    </div>
</template>

<script>
export default {
    name:'password-icon',
    props:['value'],
    methods:{
        changeValue: function(val){
            this.$emit("input", val)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/password_icon.vue